import * as React from "react";

import { Button, Stack, Theme, useTheme } from "@mui/material";

import { Link } from "react-router-dom";
import Logo from "@/components/normal/logo";
import MiniContainer from "@/containers/holders/miniContainer";
import PageWrapper from "@/containers/page-wrapper";
import RegisterInputs from "./inputs";
import RegisterVerifyEmail from "./verify-email";
import { routeNames } from "@/navigation";
import { useTranslation } from "react-i18next";

interface IRegisterPageProps {}

export enum RegisterSteps {
  "Inputs",
  "CheckEmail",
}

const RegisterPage: React.FunctionComponent<IRegisterPageProps> = () => {
  const theme = useTheme<Theme>();

  const [email, setEmail] = React.useState("");

  const [step, setStep] = React.useState(RegisterSteps.Inputs);

  const changeStep = (step: RegisterSteps) => setStep(step);

  const { t } = useTranslation(["inputValidations", "common"]);

  const RenderContent = () => {
    switch (step) {
      case RegisterSteps.Inputs:
        return <RegisterInputs setEmail={setEmail} changeStep={changeStep} />;
      case RegisterSteps.CheckEmail:
      default:
        return <RegisterVerifyEmail changeStep={changeStep} email={email} />;
    }
  };

  return (
    <PageWrapper title={t("common:login")} bgcolor={theme.palette.common.white}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ py: 3 }}
      >
        <Logo />
        <Link to={routeNames.login}>
          <Button variant="outlined" color="inherit">
            {t("common:login")}
          </Button>
        </Link>
      </Stack>
      <MiniContainer width={400}>
        <RenderContent />
      </MiniContainer>
    </PageWrapper>
  );
};

export default RegisterPage;
